import styled from 'styled-components';
import { TradeCard } from '../../PendingNegotiationCard/Styles';

export const LoadingTradeCard = styled(TradeCard)`
  padding-bottom: 0px;
`;

export const LoadingFooter = styled.div`
  border-top: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  padding: 18px;
`;

export const LoadingContentContainer = styled.div`
  display: flex;
`;

export const LoadingContentInfo = styled.div`
  padding: 20px;
`;

export const LoadingContentRow = styled.div`
  padding-bottom: 10px;
`;
